import { TFunction } from "i18next";

import {
  getCommonRenderers,
  getCommonColumnDefs,
} from "fe-shared-transactions/src/components/InvoicesDataGrid/modules/config";

export const getColumnDefs = (t: TFunction) => getCommonColumnDefs(t);

export const getRenderers = () => getCommonRenderers();
